import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import {
  FaCreditCard,
  FaWallet,
  FaBitcoin,
  FaChevronRight,
} from "react-icons/fa";

import "./Wallets.css";

/* =========================================================
   WALLET TRANSLATIONS
   Supports the same 31 language codes used by LanguageSelector
========================================================= */

const translations = {
  en: {
    kicker: "WALLET CENTRE",
    title: "Choose Your Wallet",
    subtitle: "Choose the type of wallet you want to use.",
    addCard: "Add Card",
    addCardDesc: "Add your debit card or credit card.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Use East Wallet for your transactions.",
    cryptoWallets: "Crypto Wallets",
    cryptoWalletsDesc: "Create and use your crypto wallets.",
  },
  sw: {
    kicker: "KITUO CHA WALLET",
    title: "Chagua Wallet Yako",
    subtitle: "Chagua aina ya wallet unayotaka kutumia.",
    addCard: "Ongeza Kadi",
    addCardDesc: "Ongeza kadi yako ya debit au credit.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Tumia East Wallet kwa miamala yako.",
    cryptoWallets: "Wallet za Crypto",
    cryptoWalletsDesc: "Fungua na utumie wallet zako za crypto.",
  },
  pt: {
    kicker: "CENTRO DE CARTEIRAS",
    title: "Escolha a Sua Carteira",
    subtitle: "Escolha o tipo de carteira que deseja utilizar.",
    addCard: "Adicionar Cartão",
    addCardDesc: "Adicione o seu cartão de débito ou crédito.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Utilize a East Wallet para as suas transações.",
    cryptoWallets: "Carteiras Crypto",
    cryptoWalletsDesc: "Crie e utilize as suas carteiras de criptomoedas.",
  },
  fr: {
    kicker: "CENTRE DES PORTEFEUILLES",
    title: "Choisissez Votre Portefeuille",
    subtitle: "Choisissez le type de portefeuille que vous souhaitez utiliser.",
    addCard: "Ajouter une carte",
    addCardDesc: "Ajoutez votre carte de débit ou de crédit.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Utilisez East Wallet pour vos transactions.",
    cryptoWallets: "Portefeuilles crypto",
    cryptoWalletsDesc: "Créez et utilisez vos portefeuilles crypto.",
  },
  es: {
    kicker: "CENTRO DE BILLETERAS",
    title: "Elige Tu Billetera",
    subtitle: "Elige el tipo de billetera que deseas utilizar.",
    addCard: "Añadir tarjeta",
    addCardDesc: "Añade tu tarjeta de débito o crédito.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Usa East Wallet para tus transacciones.",
    cryptoWallets: "Billeteras crypto",
    cryptoWalletsDesc: "Crea y utiliza tus billeteras de criptomonedas.",
  },
  "pt-AO": {
    kicker: "CENTRO DE CARTEIRAS",
    title: "Escolha a Sua Carteira",
    subtitle: "Escolha o tipo de carteira que pretende utilizar.",
    addCard: "Adicionar Cartão",
    addCardDesc: "Adicione o seu cartão de débito ou crédito.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Utilize a East Wallet nas suas transações.",
    cryptoWallets: "Carteiras Crypto",
    cryptoWalletsDesc: "Crie e utilize as suas carteiras de criptomoedas.",
  },
  ar: {
    kicker: "مركز المحافظ",
    title: "اختر محفظتك",
    subtitle: "اختر نوع المحفظة التي تريد استخدامها.",
    addCard: "إضافة بطاقة",
    addCardDesc: "أضف بطاقة الخصم أو بطاقة الائتمان الخاصة بك.",
    eastWallet: "East Wallet",
    eastWalletDesc: "استخدم East Wallet لإجراء معاملاتك.",
    cryptoWallets: "محافظ العملات الرقمية",
    cryptoWalletsDesc: "أنشئ محافظ العملات الرقمية الخاصة بك واستخدمها.",
  },
  zh: {
    kicker: "钱包中心",
    title: "选择您的钱包",
    subtitle: "选择您想使用的钱包类型。",
    addCard: "添加银行卡",
    addCardDesc: "添加您的借记卡或信用卡。",
    eastWallet: "East Wallet",
    eastWalletDesc: "使用 East Wallet 进行交易。",
    cryptoWallets: "加密货币钱包",
    cryptoWalletsDesc: "创建并使用您的加密货币钱包。",
  },
  hi: {
    kicker: "वॉलेट केंद्र",
    title: "अपना वॉलेट चुनें",
    subtitle: "वह वॉलेट चुनें जिसका आप उपयोग करना चाहते हैं।",
    addCard: "कार्ड जोड़ें",
    addCardDesc: "अपना डेबिट या क्रेडिट कार्ड जोड़ें।",
    eastWallet: "East Wallet",
    eastWalletDesc: "अपने लेन-देन के लिए East Wallet का उपयोग करें।",
    cryptoWallets: "क्रिप्टो वॉलेट",
    cryptoWalletsDesc: "अपने क्रिप्टो वॉलेट बनाएँ और उनका उपयोग करें।",
  },
  bn: {
    kicker: "ওয়ালেট কেন্দ্র",
    title: "আপনার ওয়ালেট বেছে নিন",
    subtitle: "আপনি যে ধরনের ওয়ালেট ব্যবহার করতে চান তা বেছে নিন।",
    addCard: "কার্ড যোগ করুন",
    addCardDesc: "আপনার ডেবিট বা ক্রেডিট কার্ড যোগ করুন।",
    eastWallet: "East Wallet",
    eastWalletDesc: "লেনদেনের জন্য East Wallet ব্যবহার করুন।",
    cryptoWallets: "ক্রিপ্টো ওয়ালেট",
    cryptoWalletsDesc: "আপনার ক্রিপ্টো ওয়ালেট তৈরি করুন ও ব্যবহার করুন।",
  },
  ru: {
    kicker: "ЦЕНТР КОШЕЛЬКОВ",
    title: "Выберите свой кошелёк",
    subtitle: "Выберите тип кошелька, который хотите использовать.",
    addCard: "Добавить карту",
    addCardDesc: "Добавьте дебетовую или кредитную карту.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Используйте East Wallet для своих транзакций.",
    cryptoWallets: "Криптокошельки",
    cryptoWalletsDesc: "Создавайте и используйте свои криптокошельки.",
  },
  de: {
    kicker: "WALLET-ZENTRUM",
    title: "Wähle deine Wallet",
    subtitle: "Wähle den Wallet-Typ, den du verwenden möchtest.",
    addCard: "Karte hinzufügen",
    addCardDesc: "Füge deine Debit- oder Kreditkarte hinzu.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Nutze East Wallet für deine Transaktionen.",
    cryptoWallets: "Krypto-Wallets",
    cryptoWalletsDesc: "Erstelle und nutze deine Krypto-Wallets.",
  },
  it: {
    kicker: "CENTRO PORTAFOGLI",
    title: "Scegli il Tuo Portafoglio",
    subtitle: "Scegli il tipo di portafoglio che vuoi utilizzare.",
    addCard: "Aggiungi carta",
    addCardDesc: "Aggiungi la tua carta di debito o di credito.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Usa East Wallet per le tue transazioni.",
    cryptoWallets: "Portafogli crypto",
    cryptoWalletsDesc: "Crea e utilizza i tuoi portafogli crypto.",
  },
  nl: {
    kicker: "WALLETCENTRUM",
    title: "Kies Je Wallet",
    subtitle: "Kies het type wallet dat je wilt gebruiken.",
    addCard: "Kaart toevoegen",
    addCardDesc: "Voeg je betaalkaart of creditcard toe.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Gebruik East Wallet voor je transacties.",
    cryptoWallets: "Crypto-wallets",
    cryptoWalletsDesc: "Maak je crypto-wallets aan en gebruik ze.",
  },
  tr: {
    kicker: "CÜZDAN MERKEZİ",
    title: "Cüzdanınızı Seçin",
    subtitle: "Kullanmak istediğiniz cüzdan türünü seçin.",
    addCard: "Kart Ekle",
    addCardDesc: "Banka veya kredi kartınızı ekleyin.",
    eastWallet: "East Wallet",
    eastWalletDesc: "İşlemleriniz için East Wallet kullanın.",
    cryptoWallets: "Kripto Cüzdanları",
    cryptoWalletsDesc: "Kripto cüzdanlarınızı oluşturun ve kullanın.",
  },
  ja: {
    kicker: "ウォレットセンター",
    title: "ウォレットを選択",
    subtitle: "使用するウォレットの種類を選択してください。",
    addCard: "カードを追加",
    addCardDesc: "デビットカードまたはクレジットカードを追加します。",
    eastWallet: "East Wallet",
    eastWalletDesc: "取引には East Wallet を使用してください。",
    cryptoWallets: "暗号資産ウォレット",
    cryptoWalletsDesc: "暗号資産ウォレットを作成して使用します。",
  },
  ko: {
    kicker: "지갑 센터",
    title: "지갑 선택",
    subtitle: "사용할 지갑 유형을 선택하세요.",
    addCard: "카드 추가",
    addCardDesc: "직불카드 또는 신용카드를 추가하세요.",
    eastWallet: "East Wallet",
    eastWalletDesc: "거래에 East Wallet을 사용하세요.",
    cryptoWallets: "암호화폐 지갑",
    cryptoWalletsDesc: "암호화폐 지갑을 만들고 사용하세요.",
  },
  vi: {
    kicker: "TRUNG TÂM VÍ",
    title: "Chọn Ví Của Bạn",
    subtitle: "Chọn loại ví bạn muốn sử dụng.",
    addCard: "Thêm thẻ",
    addCardDesc: "Thêm thẻ ghi nợ hoặc thẻ tín dụng của bạn.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Sử dụng East Wallet cho các giao dịch của bạn.",
    cryptoWallets: "Ví tiền mã hóa",
    cryptoWalletsDesc: "Tạo và sử dụng các ví tiền mã hóa của bạn.",
  },
  th: {
    kicker: "ศูนย์กระเป๋าเงิน",
    title: "เลือกกระเป๋าเงินของคุณ",
    subtitle: "เลือกประเภทกระเป๋าเงินที่คุณต้องการใช้",
    addCard: "เพิ่มบัตร",
    addCardDesc: "เพิ่มบัตรเดบิตหรือบัตรเครดิตของคุณ",
    eastWallet: "East Wallet",
    eastWalletDesc: "ใช้ East Wallet สำหรับธุรกรรมของคุณ",
    cryptoWallets: "กระเป๋าเงินคริปโต",
    cryptoWalletsDesc: "สร้างและใช้กระเป๋าเงินคริปโตของคุณ",
  },
  id: {
    kicker: "PUSAT DOMPET",
    title: "Pilih Dompet Anda",
    subtitle: "Pilih jenis dompet yang ingin Anda gunakan.",
    addCard: "Tambah Kartu",
    addCardDesc: "Tambahkan kartu debit atau kartu kredit Anda.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Gunakan East Wallet untuk transaksi Anda.",
    cryptoWallets: "Dompet Kripto",
    cryptoWalletsDesc: "Buat dan gunakan dompet kripto Anda.",
  },
  ms: {
    kicker: "PUSAT DOMPET",
    title: "Pilih Dompet Anda",
    subtitle: "Pilih jenis dompet yang ingin anda gunakan.",
    addCard: "Tambah Kad",
    addCardDesc: "Tambah kad debit atau kad kredit anda.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Gunakan East Wallet untuk transaksi anda.",
    cryptoWallets: "Dompet Kripto",
    cryptoWalletsDesc: "Cipta dan gunakan dompet kripto anda.",
  },
  ur: {
    kicker: "والٹ سینٹر",
    title: "اپنا والٹ منتخب کریں",
    subtitle: "وہ والٹ منتخب کریں جسے آپ استعمال کرنا چاہتے ہیں۔",
    addCard: "کارڈ شامل کریں",
    addCardDesc: "اپنا ڈیبٹ یا کریڈٹ کارڈ شامل کریں۔",
    eastWallet: "East Wallet",
    eastWalletDesc: "اپنے لین دین کے لیے East Wallet استعمال کریں۔",
    cryptoWallets: "کرپٹو والٹس",
    cryptoWalletsDesc: "اپنے کرپٹو والٹس بنائیں اور استعمال کریں۔",
  },
  fa: {
    kicker: "مرکز کیف پول",
    title: "کیف پول خود را انتخاب کنید",
    subtitle: "نوع کیف پول مورد نظر خود را انتخاب کنید.",
    addCard: "افزودن کارت",
    addCardDesc: "کارت نقدی یا اعتباری خود را اضافه کنید.",
    eastWallet: "East Wallet",
    eastWalletDesc: "برای تراکنش‌های خود از East Wallet استفاده کنید.",
    cryptoWallets: "کیف پول‌های رمزارز",
    cryptoWalletsDesc: "کیف پول‌های رمزارز خود را ایجاد و استفاده کنید.",
  },
  ha: {
    kicker: "CIBIYAR WALLET",
    title: "Zaɓi Wallet ɗinka",
    subtitle: "Zaɓi nau'in wallet da kake son amfani da shi.",
    addCard: "Ƙara Kati",
    addCardDesc: "Ƙara katin debit ko katin credit ɗinka.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Yi amfani da East Wallet don mu'amalolinka.",
    cryptoWallets: "Wallet na Crypto",
    cryptoWalletsDesc: "Ƙirƙiri kuma yi amfani da wallet ɗin crypto ɗinka.",
  },
  yo: {
    kicker: "ÀÁRÍN WALLET",
    title: "Yan Wallet Rẹ",
    subtitle: "Yan irú wallet tí o fẹ́ lò.",
    addCard: "Fi Kaadi Kún",
    addCardDesc: "Fi kaadi debit tàbí credit rẹ kún.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Lo East Wallet fún àwọn ìṣòwò rẹ.",
    cryptoWallets: "Àwọn Wallet Crypto",
    cryptoWalletsDesc: "Ṣẹ̀dá àti lo àwọn wallet crypto rẹ.",
  },
  zu: {
    kicker: "ISIKHUNGO SE-WALLET",
    title: "Khetha I-Wallet Yakho",
    subtitle: "Khetha uhlobo lwe-wallet ofuna ukulusebenzisa.",
    addCard: "Engeza Ikhadi",
    addCardDesc: "Engeza ikhadi lakho le-debit noma le-credit.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Sebenzisa i-East Wallet ekuthengiselaneni kwakho.",
    cryptoWallets: "Ama-Crypto Wallet",
    cryptoWalletsDesc: "Dala futhi usebenzise ama-crypto wallet akho.",
  },
  am: {
    kicker: "የዋሌት ማዕከል",
    title: "ዋሌትዎን ይምረጡ",
    subtitle: "መጠቀም የሚፈልጉትን የዋሌት አይነት ይምረጡ።",
    addCard: "ካርድ ያክሉ",
    addCardDesc: "የዴቢት ወይም የክሬዲት ካርድዎን ያክሉ።",
    eastWallet: "East Wallet",
    eastWalletDesc: "ለግብይቶችዎ East Wallet ይጠቀሙ።",
    cryptoWallets: "የክሪፕቶ ዋሌቶች",
    cryptoWalletsDesc: "የክሪፕቶ ዋሌቶችዎን ይፍጠሩ እና ይጠቀሙ።",
  },
  so: {
    kicker: "XARUNTA WALLET-KA",
    title: "Dooro Wallet-kaaga",
    subtitle: "Dooro nooca wallet-ka aad rabto inaad isticmaasho.",
    addCard: "Ku dar Kaarka",
    addCardDesc: "Ku dar kaarkaaga debit ama credit.",
    eastWallet: "East Wallet",
    eastWalletDesc: "U isticmaal East Wallet macaamilladaada.",
    cryptoWallets: "Wallet-yada Crypto",
    cryptoWalletsDesc: "Samee oo isticmaal wallet-yadaada crypto.",
  },
  rw: {
    kicker: "AHO WALLET",
    title: "Hitamo Wallet Yawe",
    subtitle: "Hitamo ubwoko bwa wallet ushaka gukoresha.",
    addCard: "Ongeraho Ikarita",
    addCardDesc: "Ongeraho ikarita ya debit cyangwa credit.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Koresha East Wallet mu bikorwa byawe by'amafaranga.",
    cryptoWallets: "Wallet za Crypto",
    cryptoWalletsDesc: "Fungura kandi ukoreshe wallet za crypto zawe.",
  },
  lg: {
    kicker: "EKITUNDU KYA WALLET",
    title: "Londa Wallet Yo",
    subtitle: "Londa ekika kya wallet ky'oyagala okukozesa.",
    addCard: "Yongerako Kaadi",
    addCardDesc: "Yongerako kaadi yo eya debit oba credit.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Kozesa East Wallet mu mirimu gyo egy'ensimbi.",
    cryptoWallets: "Wallet za Crypto",
    cryptoWalletsDesc: "Kola era okozese wallet zo eza crypto.",
  },
  af: {
    kicker: "BEURBEURSENTRUM",
    title: "Kies Jou Beursie",
    subtitle: "Kies die tipe beursie wat jy wil gebruik.",
    addCard: "Voeg Kaart By",
    addCardDesc: "Voeg jou debiet- of kredietkaart by.",
    eastWallet: "East Wallet",
    eastWalletDesc: "Gebruik East Wallet vir jou transaksies.",
    cryptoWallets: "Kripto-beursies",
    cryptoWalletsDesc: "Skep en gebruik jou kripto-beursies.",
  },
};

const supportedLanguages = Object.keys(translations);

function getSavedLanguage() {
  const saved =
    localStorage.getItem("language") ||
    localStorage.getItem("appLanguage") ||
    localStorage.getItem("lang") ||
    "en";

  return supportedLanguages.includes(saved) ? saved : "en";
}

const Wallets = () => {
  const [language, setLanguage] = useState(getSavedLanguage);

  useEffect(() => {
    const syncLanguage = (event) => {
      // LanguageSelector may send the language in the event detail.
      const eventLanguage = event?.detail?.language;

      if (
        eventLanguage &&
        supportedLanguages.includes(eventLanguage)
      ) {
        setLanguage(eventLanguage);
        return;
      }

      // Also support changes made directly to localStorage.
      setLanguage(getSavedLanguage());
    };

    window.addEventListener("languageChanged", syncLanguage);
    window.addEventListener("storage", syncLanguage);

    // Sync once more when the component mounts.
    setLanguage(getSavedLanguage());

    return () => {
      window.removeEventListener("languageChanged", syncLanguage);
      window.removeEventListener("storage", syncLanguage);
    };
  }, []);

  const t = translations[language] || translations.en;

  const isRtl = ["ar", "ur", "fa"].includes(language);

  return (
    <div className="wallets-page" dir={isRtl ? "rtl" : "ltr"}>
      {/* HEADER */}
      <div className="wallets-header">
        <span className="wallets-kicker">
          {t.kicker}
        </span>

        <h1>{t.title}</h1>

        <p>{t.subtitle}</p>
      </div>

      {/* WALLET OPTIONS */}
      <div className="wallets-list">
        {/* ADD CARD */}
        <Link to="/add-card" className="wallet-option-card">
          <div className="wallet-option-icon card-icon">
            <FaCreditCard />
          </div>

          <div className="wallet-option-content">
            <h2>{t.addCard}</h2>
            <p>{t.addCardDesc}</p>
          </div>

          <FaChevronRight className="wallet-option-arrow" />
        </Link>

        {/* EAST WALLET */}
        <Link to="/East-Wallet" className="wallet-option-card">
          <div className="wallet-option-icon east-icon">
            <FaWallet />
          </div>

          <div className="wallet-option-content">
            <h2>{t.eastWallet}</h2>
            <p>{t.eastWalletDesc}</p>
          </div>

          <FaChevronRight className="wallet-option-arrow" />
        </Link>

        {/* CRYPTO WALLET */}
        <Link to="/Crypto-Wallets" className="wallet-option-card">
          <div className="wallet-option-icon crypto-icon">
            <FaBitcoin />
          </div>

          <div className="wallet-option-content">
            <h2>{t.cryptoWallets}</h2>
            <p>{t.cryptoWalletsDesc}</p>
          </div>

          <FaChevronRight className="wallet-option-arrow" />
        </Link>
      </div>
    </div>
  );
};

export default Wallets;